<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/factory/calendar/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('shebeimingcheng')"  >
						<yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIdList" >
						</yi_data_select>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button v-if="utils.checkPower('web_scheduling_factory_calendar_create')" size="mini" @click="yt.showEditDialog('xinzeng',null,'w1');setAddEnable()" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<!-- <template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
				</el-button>
			</template> -->
			<!-- 自定义某个字段 -->

			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button v-if="utils.checkPower('web_scheduling_factory_calendar_update')" type="text" @click="yt.showEditDialog('bianji', scope.row,'w1')">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" v-if="utils.checkPower('web_scheduling_factory_calendar_equipment_calender_map_button')"
							@click="yt.editObj=utils.copy(scope.row);isShowDetailDialog=true">{{$t('shebeirilitu')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button v-if="utils.checkPower('web_scheduling_factory_calendar_delete')" type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/factory/calendar/delete')">
							{{$t('shanchu')}}
						</el-button>
					</el-col>

				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<!-- <div class="dialog-scroller"> -->
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('rilifangan')" required>
						<el-select v-model="yt.editObj.calendarSchemeId">
							<el-option v-for="plan in calendarPlans" :label="$t(plan.name)" :value="plan.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('shebei')" required>
						<yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.editObj.equipmentIdList" >
						</yi_data_select>
					</el-form-item>
					<el-form-item :label="$t('beizhu')" >
						<el-input v-model="yt.editObj.remark"></el-input>
					</el-form-item>
				</el-form>
				<!-- </div> -->
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
						@click="yt.req('POST','/web/factory/calendar/create')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('shebei')" class="noborder">
						<yi_data_select :disabled="true"  :type="'equipment'" :ids.sync="yt.editObj.equipmentId" >
						</yi_data_select>
					</el-form-item>
					<el-form-item :label="$t('rilifangan')" required>
						<el-select v-model="yt.editObj.calendarSchemeId">
							<el-option v-for="plan in calendarPlans" :label="$t(plan.name)" :value="plan.id"></el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item :label="$t('beizhu')" >
						<el-input v-model="yt.editObj.remark"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
						@click="yt.req('POST','/web/factory/calendar/update')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			


		</el-dialog>
		<el-drawer :visible.sync="isShowDetailDialog" :show-close="false" :direction="'rtl'" :size="'80%'"
			:destroy-on-close="true" :withHeader="false">
				<calendar_gantt v-if="isShowDetailDialog" :factoryCalendarId="yt.editObj.id"></calendar_gantt>
		</el-drawer>
	</div>
</template>
<!-- /quality/inspection/standard/details/get -->
<script type="text/javascript">
	import calendar_gantt from '@@/pages/web/scheduling/factory_calendar/calendar_gantt/index.vue'
	export default {
		name: 'web_scheduling_factory_calendar_list',
		components: {
			calendar_gantt,
		},
		data() {
			return {
				isShowDetailDialog:false,
				calendarPlans: [],
				columns: [{
					label: 'shebeimingcheng',
					prop: 'equipment.name',
				}, {
					label: 'rilifanganmingcheng',
					prop: 'calendarScheme.name',

				}, {
					label: 'beizhu',
					prop: 'remark',
				}, {
					label: 'chuangjianren',
					prop: 'createByObject.nickname',
				}, {
					label: 'chuangjianshijian',
					prop: 'createTime',
					type: 'time',
					format: 'YYYY-MM-DD'
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 220,
					fixed: 'right'
				}]
			};
		},
		created() {
			this.getCalendarPlans()
			setTimeout(() => {
				this.yt.get(1);
			}, 300)

		},

		methods: {
			
			getCalendarPlans() {
				let params = {
					pageSize:999,
					pageNum:1,
				}
				this.http.get('/web/calendar/scheme/page',{params:params}).then((res) => {
					this.calendarPlans = res.data.rows
				}).catch((msg) => {
					this.utils.errorMessage(msg);
				})
			},


		}
	};
</script>